import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";

export default class Instructions extends Component {
  render() {
    return (
      <section className="instructions">

        {/* <h2>Setting up your <Route exact path="/classic-landing/">Classic overlay</Route><Route exact path="/slanted-landing/">Slanted overlay</Route><Route exact path="/minimal-landing/">Minimal overlay</Route><Route exact path="/max-landing/">Max overlay</Route><Route exaxt path="/alert-landing/">donation alerts</Route></h2>

        <p>Create a <a href="https://stjude.tiltify.com/"> St.&nbsp;Jude fundraising campaign</a>.</p>

        <p>Click the <em>Get <Route exact path="/classic-landing/">Classic Overlay</Route><Route exact path="/slanted-landing/">Slanted Overlay</Route><Route exact path="/minimal-landing/">Minimal Overlay</Route><Route exact path="/max-landing/">Max Overlay</Route><Route exact path="/alert-landing/">Donation Alerts</Route></em> link above</p>

        <p>Grab your username and campaign slug from your St.&nbsp;Jude PLAY LIVE campaign. You can find these in your Tiltify fundraising dashboard.</p>

        <p><strong>Example Tiltify URL:</strong><br /> <em>https://tiltify.com/@warchant/warchants-2019-playlive-campaign-to-end-childhood-cancer</em></p>
        
        <p><strong>Example username:</strong> warchant</p>

        <p><strong>Example campaign slug:</strong> warchants-2019-playlive-campaign-to-end-childhood-cancer</p> */}
        
        <section className="inner-row gutters constrain">
          <div className="col-4 i-steps">
            <p><strong>Add overlay to OBS:</strong></p>
            
            <ol>
              <li>Add a new browser source and give it a name</li>
              <li>Copy and paste url into URL field</li>
              <Router>
                <Switch>
                  <Route exact path="/classic-landing/"><li>Set width: 1120px height: 110px</li></Route>
                  <Route exact path="/slanted-landing/"><li>Set width: 1120px height: 110px</li></Route>
                  <Route exact path="/minimal-landing/"><li>Set width: 300px height: 95px</li></Route>
                  <Route exact path="/max-landing/"><li>Set width: 1920px height: 90px</li></Route>
                  <Route exact path="/leaderboard-landing/"><li>Set width and height to your preferred size</li></Route>
                </Switch>
              </Router>
              {/* <li>Check checkboxes "Shutdown source when not visible" and "Refresh browser when scene becomes active"</li> */}
              <li>Click OK</li>
            </ol>
          </div>
          
          <div className="col-4 i-steps">
            <p><strong>Add overlay to Twitch Studio:</strong></p>
            <ol>
              <li>Add a new "Embed Webpage" layer</li>
              <Router>
                <Switch>
                  <Route exact path="/classic-landing/"><li>Set width: 1120px height: 110px</li></Route>
                  <Route exact path="/slanted-landing/"><li>Set width: 1120px height: 110px</li></Route>
                  <Route exact path="/minimal-landing/"><li>Set width: 300px height: 95px</li></Route>
                  <Route exact path="/max-landing/"><li>Set width: 1920px height: 90px</li></Route>
                  <Route exact path="/leaderboard-landing/"><li>Set width and height to your preferred size</li></Route>
                </Switch>
              </Router>
              <li>Set sizing to Fit</li>
              <li>Copy and paste url into URL field and click arrow button</li>
              <li>Click Save</li>
            </ol>
          </div>

          <div className="col-4 i-steps">
            <p><strong>Add overlay to XSplit:</strong></p>
            <ol>
              <li>At the bottom left of XSplit press the add button on the desired scene.</li>
              <li>Select “Webpage…”</li>
              <li>Copy and paste url into URL field</li>
            </ol>
          </div>
        </section>
        
      </section>
    );
  }
}